<template>
    <div class="ffPicUploadList">
        <draggable
            :handle="'.ffUploadLi'"
            :filter="'.ffPic'"
        >
            <template v-if="pics.length > 0">
                <template v-for="(pic, index) in pics">
                    <div class="ffUploadLi" :key="index">
                        <div class="ffPic" v-viewer="{ navbar: false, toolbar: false, title: false, url: 'src-source', zIndex: 10000 }">
                            <img
                                :src="pic.url['w50h50']"
                                :src-source="pic.url['w0h0']"
                            >
                        </div>
                        <div class="ffToolList">
                            <span
                                @click="copyLinkToClipboard(index)"
                                ref="copyLink"
                                v-if="!hideListButtonKeys.includes('copy')"
                            >
                                <font-awesome-icon icon="clipboard" />
                                <input type="hidden" ref="copyLinkInput" class="copyLink" :value="pic.url['w0h0']">
                            </span>
                            <b-tooltip
                                v-if="!hideListButtonKeys.includes('copy')"
                                :target="() => $refs.copyLink[index]"
                                title="複製圖片路徑"
                                triggers="hover"
                            />
                            <span
                                @click="onPicDelete(pic.id)"
                                ref="deleteIcon"
                                v-if="!hideListButtonKeys.includes('delete')"
                            >
                                <font-awesome-icon icon="trash" />
                            </span>
                            <b-tooltip
                                v-if="!hideListButtonKeys.includes('delete')"
                                :target="() => $refs.deleteIcon[index]"
                                title="刪除圖片"
                                triggers="hover"
                            />
                        </div>
                        <input type="hidden" :name="inputName + '[]'" :value="pic.id">
                    </div>
                </template>
            </template>
        </draggable>
    </div>
</template>

<script>
import Draggable from "vuedraggable";

export default {
    props: {
        inputName: {
            type: String,
            default: ''
        },
        pics: {
            type: Array,
            default: () => {
                return []
            }
        },
        hideListButtonKeys: {
          type: Array,
          default: () => {
            return []
          }
        },
    },
    data: () => {
        return {
            message: ''
        }
    },
    components: {
        Draggable,
    },
    computed: {
    },
    methods: {
        onPicDelete: function( id ) {

            if( ! confirm('確定要刪除圖片嗎？') )
            {
                return false;
            }

            this.pics.forEach( (pic, index) => {
                if( pic.id == id )
                {
                    this.pics.splice( index, 1 );
                    return true;
                }
            });
        },
        copyLinkToClipboard( index ) {
            let copyLink = this.$refs.copyLinkInput[index];
            console.log(copyLink);
            copyLink.setAttribute('type', 'text');
            copyLink.select();

            try {
                var successful = document.execCommand('copy');
                alert('複製路徑成功');
            } catch (err) {
                alert('複製路徑失敗');
            }

            /* unselect the range */
            copyLink.setAttribute('type', 'hidden');
            window.getSelection().removeAllRanges();
        },
    },
    mounted: function () {
    }
};
</script>

<style lang="scss" scoped>
$color-blue: #027de5;

.ffPicUploadList{
    overflow: hidden;
    .ffUploadLi{
        float: left;
        margin: 0 5px 15px 0;
        padding: 7px;
        overflow: hidden;
        border: 2px solid #FFF;
        background: #DDD;
        border-radius: 5px;
        cursor: move;
        .ffPic {
            display: block;
            width: 50px;
            height: 50px;
            margin-bottom: 5px;
            border: 2px solid #FFF;
            overflow: hidden;
            cursor: zoom-in;
            img{
                width: 50px;
                height: 50px;
                float: left;
            }
        }
        .ffToolList{
            height: auto;
            width: 50px;
            padding-left: 6px;
            span {
                float: left;
                color: #666;
                cursor: pointer;
                font-size: 15px;
                display: block;
                line-height: 20px;
                margin-right: 7px;
                svg {
                    width: 15px;
                    height: 15px;
                }
            }
        }
    }
}

</style>
